import { z } from 'zod';

export type CreatePhaseTypePayload = z.infer<typeof createPhaseTypePayloadSchema>;

export const createPhaseTypePayloadSchema = z.object({
  color: z.string(),
  description: z.string().optional(),
  name: z.string(),
});
